import React, { useCallback, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loader } from 'semantic-ui-react';
import { getUser } from './Api/api';
import { PrivateRoute } from './Components/PrivateRoute';
import CardEditPage from './Pages/CardEditPage/CardEditPage';
import LoginPage from './Pages/LoginPage/LoginPage';
import MainPage from './Pages/MainPage/MainPage';

function App() {
    const [isAuthorized, setIsAuthorized] = useState(null);
    const [phone, setPhone] = useState('');

    useEffect(() => {
        getUser()
            .then((result) => {
                setIsAuthorized(true);
                setPhone(result.phone);
            })
            .catch(() => setIsAuthorized(false));
    }, []);

    const onLoggedIn = useCallback(() => setIsAuthorized(true), []);

    if (isAuthorized === null) {
        return <Loader active />
    }

    return (
        <>
            <ToastContainer position="bottom-left" />
            <Routes>
                <Route path="/login" element={<LoginPage onLoggedIn={onLoggedIn} />} />
                <Route path="/" element={<PrivateRoute isAuthorized={isAuthorized}><MainPage phone={phone} /></PrivateRoute>} />
                <Route path="/card/:cardId" element={<PrivateRoute isAuthorized={isAuthorized}><CardEditPage /></PrivateRoute>} />
            </Routes>
        </>
    );
}

export default App;